/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_SuccessInputs */

const es_common_success = /** @type {(inputs: Common_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operación exitosa`)
};

const en_common_success = /** @type {(inputs: Common_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success`)
};

/**
* | output |
* | --- |
* | "Success" |
*
* @param {Common_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const common_success = /** @type {((inputs?: Common_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_success(inputs)
	return en_common_success(inputs)
});
export { common_success as "common.success" }